import { why } from '../content.js'
import Icon from '../components/Icon.jsx'

export default function Why() {
  return (
    <section className="section" id="why">
      <div className="container">
        <div className="section-head">
          <h2>{why.title} <span className="grad-po">{why.titleAccent}</span></h2>
          <p>{why.subtitle} <strong>{why.subtitleBold}</strong></p>
        </div>
        <div className="stats">
          {why.stats.map((s) => (
            <div key={s.label} className="stat"><b>{s.value}</b><span>{s.label}</span></div>
          ))}
        </div>
        <div className="cards">
          {why.items.map((it) => (
            <article key={it.title} className="card">
              <div className={`card-icon tone-${it.tone}`}><Icon name={it.icon} /></div>
              <h3>{it.title}</h3>
              <p>{it.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
